import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-12" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Subitens")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo ss-margin-campos" }, "Ativo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" })
], -1)
const _hoisted_8 = { class: "ant-col ant-col-xs-2 ant-col-xl-1" }
const _hoisted_9 = {
  title: "Arraste para cima ou para baixo para ordenar os itens",
  class: "ss-mover ss-alinhar-centro"
}
const _hoisted_10 = { class: "ant-col ant-col-xs-18 ant-col-xl-11" }
const _hoisted_11 = { class: "ss-margin-campos" }
const _hoisted_12 = { class: "ant-col ant-col-xs-20 ant-col-xl-6" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ant-col ant-col-xs-20 ant-col-xl-5" }
const _hoisted_15 = { class: "ss-margin-campos" }
const _hoisted_16 = { class: "ant-col ant-col-xs-2 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-22" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" })
], -1)
const _hoisted_28 = { class: "ant-col ant-col-xs-2 ant-col-xl-1" }
const _hoisted_29 = {
  title: "Arraste para cima ou para baixo para ordenar os sub itens",
  class: "ss-mover ss-alinhar-centro"
}
const _hoisted_30 = { class: "ant-col ant-col-xs-20 ant-col-xl-22" }
const _hoisted_31 = { class: "ss-margin-campos" }
const _hoisted_32 = { class: "ant-col ant-col-xs-2 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, { titulo: "ITENS" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  label: "Novo valor",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      ref: "campoNovoValorItem",
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoValor) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.apresentarNovosSubItensCaracteristica()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.novoValor]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-block",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.apresentarNovosSubItensCaracteristica()))
                    }, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_icone, { nome: "editar" }),
                        _createTextVNode(" Subitens")
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary ant-btn-block",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.adicionarItem && _ctx.adicionarItem(...args)))
                    }, _hoisted_6)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _hoisted_7,
        (_ctx.computedItensListaSubItens.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhum item foi adicionado ainda"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          name: "ss-form-caracteristica-itens-lista-sub-itens",
          class: "ss-altura-rolagem-padrao",
          model: _ctx.computedItensListaSubItens
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.computedItensListaSubItens,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedItensListaSubItens) = $event)),
              "item-key": "index",
              handle: ".ss-mover"
            }, {
              item: _withCtx(({element,index}) => [
                (_openBlock(), _createElementBlock("div", {
                  class: "ant-row ss-grade-personalizada-linha",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_icone, {
                        style: {"font-size":"15px"},
                        nome: "ordenar-lista"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_input, {
                        class: "ant-input",
                        value: element.valor,
                        "onUpdate:value": ($event: any) => ((element.valor) = $event),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.adicionarItem()), ["enter"]))
                      }, null, 8, ["value", "onUpdate:value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-block",
                      onClick: ($event: any) => (_ctx.apresentarSubItensCaracteristica(index,element))
                    }, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_icone, { nome: "editar" }),
                        _createTextVNode(" Subitens")
                      ])
                    ], 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_selecionar_sim_nao, {
                        valor: element.ativo,
                        "onUpdate:valor": ($event: any) => ((element.ativo) = $event)
                      }, null, 8, ["valor", "onUpdate:valor"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      title: "Remover",
                      onClick: ($event: any) => (_ctx.removerItem(index))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_17)
                  ])
                ]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_modal, {
          keyboard: false,
          centered: "",
          width: 700,
          visible: _ctx.state.apresentarSubItems,
          "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.apresentarSubItems) = $event)),
          "wrap-class-name": "ss-modal-cadastros"
        }, {
          title: _withCtx(() => [
            _createTextVNode(" Subitens do Item Característica: " + _toDisplayString(_ctx.state.valorCaracteristicaItem), 1)
          ]),
          closeIcon: _withCtx(() => [
            _createVNode(_component_icone, { nome: "voltar" })
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ocultarSubItensCaracteristica && _ctx.ocultarSubItensCaracteristica(...args)))
              }, _hoisted_19),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmarSubItensCaracteristica && _ctx.confirmarSubItensCaracteristica(...args)))
              }, _hoisted_21)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, {
                      label: "Novo valor",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          ref: "campoNovoValorSubItem",
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.novoValorSubItem) = $event)),
                          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.adicionarSubItem()), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.state.novoValorSubItem]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-primary ant-btn-block",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.adicionarSubItem && _ctx.adicionarSubItem(...args)))
                        }, _hoisted_26)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_27,
            _createVNode(_component_a_form, {
              name: "ss-form-caracteristica-itens-lista-simples",
              class: "ss-altura-rolagem-padrao",
              model: _ctx.state.subItens
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.state.subItens,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.subItens) = $event)),
                  "item-key": "index",
                  handle: ".ss-mover"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      class: "ant-row ss-grade-personalizada-linha",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_icone, {
                            style: {"font-size":"15px"},
                            nome: "ordenar-lista"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_a_input, {
                            class: "ant-input",
                            value: element.valor,
                            "onUpdate:value": ($event: any) => ((element.valor) = $event)
                          }, null, 8, ["value", "onUpdate:value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("a", {
                          title: "Remover",
                          onClick: ($event: any) => (_ctx.removerSubItem(index))
                        }, [
                          _createVNode(_component_icone, { nome: "excluir" })
                        ], 8, _hoisted_33)
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    })
  ]))
}